import { HttpClient } from "@angular/common/http";
import {
  Component,
  HostListener,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { forkJoin, of } from "rxjs";
import { DataService } from "src/app/data.service";
import { map, switchMap, tap } from "rxjs/operators";
import { NgForm, UntypedFormControl } from "@angular/forms";
import { db, qService } from "src/app/db.service";
import { ToastrService } from "ngx-toastr";
import { NewBankGroupDialogComponent } from "src/app/dialogs/new-bank-group-dialog/new-bank-group-dialog.component";
import _ from "lodash";
import * as _moment from "moment";
import { PusherService } from "src/app/pusher.service";
import { CustomersService } from "src/app/customers/customers.service";
import { AuthService } from "src/app/auth.service";
import { ConfirmationDialogComponent } from "src/app/shared/confirmation-dialog/confirmation-dialog.component";
import { v4 as uuidv4 } from "uuid";

const moment = _moment;

@Component({
  selector: "app-bank-dialog",
  templateUrl: "./bank-dialog.component.html",
  styleUrls: ["./bank-dialog.component.css"],
})
export class BankDialogComponent implements OnInit {
  @ViewChild("inv") form: NgForm;
  dataLoading: boolean = false;
  date;
  selectedBankGroupId: number;
  selectedCashboxId: number = this._dataService.cashBox()[0].id
    ? this._dataService.cashBox()[0].id
    : 1;
  selectedEdvId: number = this._dataService
    .cashBox()
    .find((c) => c.name == "ƏDV")
    ? this._dataService.cashBox().find((c) => c.name == "ƏDV").id
    : 1;
  bankAmount;
  details;
  bankGroupsByType = [];
  dateNow = moment(Date.now()).format("YYYY-MM-DD");
  transactionNo: string = "";
  bankEntry;
  deleteTransaction = of({});
  customerBalance;
  editMode: boolean = false;
  copyMode: boolean = false;
  user: string;
  refersTo;
  edvArray = [
    { id: 1, name: "ƏDV Daxil" },
    { id: 2, name: "ƏDV Xaric" },
  ];
  selectedEdv: number = 1;
  edvPercentage: number = 18;

  @HostListener("keydown.enter", ["$event"])
  onKeyDown() {
    var addButton = document.querySelector("#addButton") as HTMLElement;
    if (this.form.valid) {
      this.addBankOrder(this.form.value, addButton);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<BankDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private http: HttpClient,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public _dataService: DataService,
    private _pusher: PusherService,
    private _authService: AuthService,
    protected _customersService: CustomersService
  ) {}

  ngOnInit(): void {
    console.log(this.dialogData);
    this.date =
      this._dataService.startDate?.value?.format("YYYY-MM-DD") ==
      this._dataService.endDate?.value?.format("YYYY-MM-DD")
        ? new UntypedFormControl(
            moment(this._dataService.endDate?.value?.format("YYYY-MM-DD"))
          )
        : new UntypedFormControl(moment());
    this.sortBankGroups();
    if (this.dialogData?.data) {
      this.selectedBankGroupId = this.dialogData.data.bankGroupId;
      this._customersService.selectedCustomerId =
        this.dialogData.data.customerId;
      this.details = this.dialogData.data.details;
      this.date = new UntypedFormControl(moment(this.dialogData.data.date));
      this.bankAmount = this.dialogData.data.income
        ? this.dialogData.data.income
        : this.dialogData.data.outgoings;
      this.selectedCashboxId = this.dialogData.cashboxId;
      this.transactionNo = this.dialogData.data.tId;
      this.editMode = this.dialogData.editMode
        ? this.dialogData.editMode
        : false;
      this.copyMode = this.dialogData.copyMode
        ? this.dialogData.copyMode
        : false;
      if (this.dialogData?.data?.transaction?.userId) {
        let userName = this._dataService
          .users()
          .find((u) => u.id == this.dialogData?.data?.transaction?.userId);
        this.user = userName ? userName.fullname : null;
      }
      this.refersTo = this.dialogData?.data?.transaction?.refersTo ?? null;
    } else {
      this._customersService.selectedCustomerId = null;
    }

    if (this.dialogData?.cashboxId) {
      this.selectedCashboxId = this.dialogData.cashboxId;
    }
  }

  async addBankOrder(data, btn) {
    const registration = await navigator.serviceWorker.ready;

    if ("sync" in registration) {
      // Background sync is available - proceed with offline-first approach
      btn.disabled = true;
      btn.firstChild.innerText = "Saxlanılır...";

      // 1. Generate temporary, unique IDs for local use
      const tempTransactionId = uuidv4();
      const tempBankId = uuidv4();
      let tempEdvId = null;

      const today = moment();

      // 2. Prepare the data objects using the temporary IDs
      const transaction = {
        id: tempTransactionId, // Use temp ID
        type: "Bank",
        sum: this.dialogData.type == "medaxil" ? data.price : -data.price,
        customerId: data.customerId,
        date: this.date.value.format("YYYY-MM-DD"),
        dateAdded: today.format("YYYY-MM-DD HH:mm:ss"),
        details: data.details,
        userId: this._authService.loggedInUserValue.id ?? null,
        syncStatus: "pending", // Mark for sync
      };

      let selectedCustomerName = _.find(this._dataService.customers(), {
        id: data.customerId,
      }).name;

      const bankEntry = {
        id: tempBankId, // Use temp ID
        transactionId: transaction,
        tId: tempTransactionId, // Link to transaction
        bankGroupId: data.bankGroupId,
        cashboxId: this.selectedCashboxId,
        income: this.dialogData.type == "medaxil" ? data.price : null,
        outgoings: this.dialogData.type == "medaxil" ? null : data.price,
        date: this.date.value.format("YYYY-MM-DD"),
        syncStatus: "pending",
        dateAdded: today.format("YYYY-MM-DD"),
        details: data.details,
        customerId: data.customerId,
        customerName: selectedCustomerName,
        bankGroupName: this._dataService
          .bankGroups()
          .find((b) => b.id == data.bankGroupId)
          ? this._dataService.bankGroups().find((b) => b.id == data.bankGroupId)
              .name
          : "Loading",
        type: this.dialogData.type == "medaxil" ? "Bank In" : "Bank Out",
      };

      let edvEntry = null;
      if (
        this.selectedEdv == 2 &&
        this.selectedCashboxId != this.selectedEdvId
      ) {
        tempEdvId = uuidv4();
        edvEntry = {
          ...bankEntry,
          id: tempEdvId, // Use temp ID
          transactionId: tempTransactionId,
          tId: tempTransactionId,
          cashboxId: this.selectedEdvId,
          income:
            this.dialogData.type == "medaxil"
              ? (data.price * this.edvPercentage) / 100
              : null,
          outgoings:
            this.dialogData.type == "medaxil"
              ? null
              : (data.price * this.edvPercentage) / 100,
          syncStatus: "pending",
        };
      }

      // 3. Prepare the payload for the background sync queue
      const queuePayload = {
        type: "ADD_BANK_ORDER", // A unique type for this operation
        payload: {
          transaction: { ...transaction, id: undefined, syncStatus: undefined }, // Don't send local-only fields
          bankEntry: { ...bankEntry, id: undefined, syncStatus: undefined },
          edvEntry: edvEntry
            ? { ...edvEntry, id: undefined, syncStatus: undefined }
            : null,
        },
        context: {
          tempTransactionId,
          tempBankId,
          tempEdvId,
          removeTransactionId:
            this.dialogData.data && this.copyMode == false
              ? this.dialogData.data.tId
              : null,
          dbName: this._dataService.dbTable, // Pass the target database name
        },
      };

      let queueRequestId = null;

      try {
        await (registration as any).sync.register("test-sync");

        await db.transaction("rw", db.transactions, db.bank, async () => {
          await db.transactions.add(transaction);
          await db.bank.add(bankEntry);
          if (edvEntry) {
            await db.bank.add(edvEntry);
          }

          if (this.dialogData.data && this.copyMode == false) {
            await db.transactions.delete(this.dialogData.data.tId);
            await db.bank
              .where("tId")
              .equals(this.dialogData.data.tId)
              .delete();
          }
        });

        // Store the queue request ID for potential cleanup
        queueRequestId = await qService.requests.add({
          payload: queuePayload,
          timestamp: Date.now(),
        });

        // 5. Register the background sync task
        await (registration as any).sync.register("app-sync");

        // 6. Give immediate success feedback
        this.dialogRef.close({
          /* return optimistic data */
        });
      } catch (error) {
        this.postOnline(data, btn);
      }
    } else {
      this.postOnline(data, btn);
    }
  }

  postOnline(data, btn) {
    this.dataLoading = true;
    btn.firstChild.innerText = "Gözləyin";
    btn.disabled = true;
    btn.innerText = "Gözləyin";

    let postBank, removeTransaction;
    let today = new UntypedFormControl(moment());

    const handleError = () => {
      this.dataLoading = false;
      btn.firstChild.innerText = "Əlavə et";
      btn.disabled = false;
      this.toastr.error("", "Xəta baş verdi, yenidən cəhd edin", {
        toastClass: "ngx-toastr",
        progressBar: true,
        timeOut: 2500,
        progressAnimation: "increasing",
      });
    };

    var transaction = {
      id: null,
      type: "Bank",
      sum: this.dialogData.type == "medaxil" ? data.price : -data.price,
      customerId: data.customerId,
      date: this.date.value.format("YYYY-MM-DD"),
      dateAdded: today.value.format("YYYY-MM-DD HH:mm:ss"),
      details: data.details,
      userId: this._authService.loggedInUserValue.id ?? null,
      refersTo: this.dialogData?.data?.tId ?? null,
    };

    if (this.dialogData.data && this.copyMode == false) {
      removeTransaction = this.http.put(
        this._dataService.dbBase +
          "api.php/records/transactions/" +
          this.dialogData.data.tId,
        { status: 2 }
      );
    } else {
      removeTransaction = of(null);
    }

    let selectedCustomerName = _.find(this._dataService.customers(), {
      id: this._customersService.selectedCustomerId,
    }).name;

    this.bankEntry = {
      bankGroupId: data.bankGroupId,
      cashboxId: this.selectedCashboxId,
      income: this.dialogData.type == "medaxil" ? data.price : null,
      outgoings: this.dialogData.type == "medaxil" ? null : data.price,
      customerId: data.customerId,
      date: this.date.value.format("YYYY-MM-DD"),
      dateAdded: today.value.format("YYYY-MM-DD"),
      details: data.details,
      customerName: selectedCustomerName,
      bankGroupName: this._dataService
        .bankGroups()
        .find((b) => b.id == data.bankGroupId)
        ? this._dataService.bankGroups().find((b) => b.id == data.bankGroupId)
            .name
        : "Loading",
      type: this.dialogData.type == "medaxil" ? "Bank In" : "Bank Out",
    };

    let edvEntry = null;
    let edvEntryId = null;

    forkJoin({
      post: this.http.post(
        this._dataService.dbBase + "api.php/records/transactions/",
        transaction
      ),
      remove: removeTransaction,
    })
      .pipe(
        map((transactionId) => {
          transaction.id = transactionId.post;
          this.bankEntry = {
            ...this.bankEntry,
            transactionId: transactionId.post,
            cashboxId: this.selectedCashboxId,
          };

          this.deleteTransaction = this.http.delete(
            this._dataService.dbBase +
              "api.php/records/transactions/" +
              transactionId.post
          );

          postBank = this.http.post(
            this._dataService.dbBase + "api.php/records/bank/",
            this.bankEntry
          );
        }),
        switchMap(() => {
          let postEdv: any = of(null);
          if (
            this.selectedEdv == 2 &&
            this.selectedCashboxId != this.selectedEdvId
          ) {
            edvEntry = {
              ...this.bankEntry,
              cashboxId: this.selectedEdvId,
              income:
                this.dialogData.type == "medaxil"
                  ? (data.price * this.edvPercentage) / 100
                  : null,
              outgoings:
                this.dialogData.type == "medaxil"
                  ? null
                  : (data.price * this.edvPercentage) / 100,
            };
            postEdv = this.http.post(
              this._dataService.dbBase + "api.php/records/bank/",
              edvEntry
            );
          }
          return forkJoin({ postBank, postEdv });
        }),
        tap((res) => {
          this.bankEntry.id = res.postBank;
          edvEntryId = res.postEdv;
        })
      )
      .subscribe({
        error: (e) => {
          forkJoin({
            deleteTransaction: this.deleteTransaction,
            storeErrorInDatabase: this._dataService.storeErrorInDatabase(
              e,
              JSON.stringify(transaction),
              JSON.stringify(this.bankEntry),
              JSON.stringify(data),
              "Bank"
            ),
          }).subscribe({
            complete: handleError,
            error: handleError,
          });
        },
        complete: () => {
          let remove =
            this.dialogData.data && this.copyMode == false
              ? this.dialogData.data?.tId
              : null;

          if (remove) {
            db.transactions.delete(remove);
            db.bank.where("tId").equals(remove).delete();
          }

          this.bankEntry = {
            ...this.bankEntry,
            transactionId: transaction,
            tId: transaction.id,
            dateAdded: today.value.format("YYYY-MM-DD"),
            details: transaction.details,
          };

          db.transactions.add(transaction, transaction.id);
          db.bank.add(this.bankEntry, this.bankEntry.id);

          if (edvEntry) {
            edvEntry = {
              ...edvEntry,
              transactionId: transaction,
              tId: transaction.id,
              dateAdded: today.value.format("YYYY-MM-DD"),
              details: transaction.details,
            };
            db.bank.add(edvEntry, edvEntry.id);
          }

          let pushData = { transaction, bank: this.bankEntry };
          this._pusher.postData(pushData).subscribe();

          this.dialogRef.close({
            ...this.bankEntry,
            remove: this.dialogData.data ? this.dialogData.data?.id : null,
          });
          this.toastr.success("", "Əlavə edildi!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
        },
      });
  }

  newBankGroupDialog(selectedBankGroupId?: number) {
    let dialogRef;
    let data: { type; data? } = { type: this.dialogData?.type };

    if (selectedBankGroupId) {
      data.data = _.find(this._dataService.bankGroups(), {
        id: selectedBankGroupId,
      });
    }

    dialogRef = this.dialog.open(NewBankGroupDialogComponent, {
      width: "465px",
      data: data,
      closeOnNavigation: true,
    });
    dialogRef.afterClosed().subscribe((dialogReturnData) => {
      if (dialogReturnData) {
        this._dataService.getBankGroups().subscribe((bankGroups) => {
          this._dataService.bankGroups.set(bankGroups);
          this.sortBankGroups();
          this._dataService.setLS("bankGroups", this._dataService.bankGroups());
          this.bankGroupsByType = [...this.bankGroupsByType];
          this.selectedBankGroupId = dialogReturnData.id
            ? dialogReturnData.id
            : dialogReturnData;
        });
      }
    });
  }

  sortBankGroups() {
    if (this.dialogData?.type == "medaxil") {
      this._dataService.bankGroups().forEach((element) => {
        if (element.bankEntryType == null || element.bankEntryType == 1) {
          this.bankGroupsByType.push(element);
        }
      });
      this.selectedBankGroupId = this.bankGroupsByType[0]
        ? this.bankGroupsByType[0].id
        : null;
    } else {
      this._dataService.bankGroups().forEach((element) => {
        if (element.bankEntryType == null || element.bankEntryType == 2) {
          this.bankGroupsByType.push(element);
        }
      });
      this.selectedBankGroupId = this.bankGroupsByType[0]
        ? this.bankGroupsByType[0].id
        : null;
    }
    this.bankGroupsByType.push({ id: 0, name: "Satış" });
  }

  async getUserBalance(customerId) {
    if (customerId) {
      (
        await this._customersService.getCustomersBalanceById(customerId)
      ).subscribe((r) => {
        let customerBalaceObj = r.find((c) => c.customerId == customerId);
        this.customerBalance = customerBalaceObj.finalBalance;
      });
    }
  }

  // GETS ORIGINAL VERSION OF TRANSACTIONS IF ITS EDITED
  getUneditedVer() {
    this.dataLoading = true;
    this.http
      .get(
        `https://tekoplast.az/jjapi/api.php/records/transactions/${this.refersTo}/?join=bank`
      )
      .subscribe((r: any) => {
        let dialogData = {
          bankGroupId: r.bank[0].bankGroupId,
          bankGroupName: r.bank[0].bankGroupId,
          transactionId: r.bank[0].transactionId,
          type: r.bank.income ? "medaxil" : "",
          cashboxId: r.bank.cashboxId || 1,
          editMode: false,
          copyMode: true,
          data: { ...r.bank[0], transaction: r },
        };

        const dialogRef = this.dialog.open(BankDialogComponent, {
          width: "700px",
          maxHeight: "700px",
          data: dialogData,
          closeOnNavigation: true,
          disableClose: this._dataService.mobileDevice ? false : true,
          panelClass: "materialDialog",
          hasBackdrop: false,
        });
        this.dataLoading = false;
      });
  }

  deleteEntry() {
    let data = `${this.dialogData.data.customerName} - ${
      this.dialogData.data.income ?? this.dialogData.data.outgoings
    } ₼`;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "500px",
      data,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.http
          .put(
            this._dataService.dbBase +
              "api.php/records/transactions/" +
              this.dialogData?.data?.tId,
            { status: 1 }
          )
          .subscribe(async () => {
            await db.transactions.delete(this.dialogData?.data?.tId);
            await db.bank
              .where("tId")
              .equals(this.dialogData?.data?.tId)
              .delete();
            this._pusher.postData("Bank Entry Deleted").subscribe();
            this.toastr.success("", "Silindi!", {
              toastClass: "ngx-toastr customToast",
              progressBar: true,
              timeOut: 2500,
              progressAnimation: "increasing",
            });
            this.dialogRef.close();
          });
      }
    });
  }

  customerDialog() {
    let data = null;
    // ANBAR GİRİŞİ OLDUQDA YENİ MÜŞTƏRİ TİPİ TƏCHİZADÇI, ƏKS HALDA MÜŞTƏRİ
    if (this.dialogData.type == "medaxil") {
      data = { customerGroupId: 1 };
    } else {
      data = { customerGroupId: 2 };
    }
    this._customersService.customerDialog(data);
  }
}
